import React, { useEffect, useState } from 'react';
import Icon from '../../../components/AppIcon';
import { formatINR } from '../../../data/games';

const WINNERS = [
  { name: 'Rajesh K.', amount: 125000, game: 'Teen Patti Gold', time: '2 min ago' },
  { name: 'Priya S.', amount: 89000, game: 'Andar Bahar Royal', time: '5 min ago' },
  { name: 'Amit P.', amount: 156000, game: 'Cricket Exchange', time: '8 min ago' },
  { name: 'Sneha M.', amount: 67000, game: 'Lightning Roulette', time: '12 min ago' },
  { name: 'Vikram R.', amount: 234000, game: 'Blackjack Premium', time: '15 min ago' },
];

const LiveStatsBar = () => {
  const [stats, setStats] = useState({
    activePlayers: 12847,
    liveTables: 156,
    todayWinners: 2341,
    totalPayout: 45678900,
  });
  const [wIndex, setWIndex] = useState(0);

  useEffect(() => {
    const s = setInterval(() => {
      setStats((p) => ({
        activePlayers: p.activePlayers + Math.floor(Math.random() * 12) - 5,
        liveTables: Math.max(120, p.liveTables + Math.floor(Math.random() * 5) - 2),
        todayWinners: p.todayWinners + (Math.random() > 0.5 ? 1 : 0),
        totalPayout: p.totalPayout + Math.floor(Math.random() * 60000),
      }));
    }, 5000);
    const w = setInterval(() => setWIndex((i) => (i + 1) % WINNERS.length), 3400);
    return () => {
      clearInterval(s);
      clearInterval(w);
    };
  }, []);

  const winner = WINNERS[wIndex];

  const tiles = [
    { icon: 'Users', label: 'Players online', value: stats.activePlayers.toLocaleString('en-IN'), color: '#5B8CFF' },
    { icon: 'Radio', label: 'Live tables', value: stats.liveTables, color: '#FF3D71' },
    { icon: 'Trophy', label: 'Winners today', value: stats.todayWinners.toLocaleString('en-IN'), color: '#F0C24B' },
    { icon: 'Banknote', label: 'Paid out today', value: formatINR(stats.totalPayout), color: '#25D366' },
  ];

  return (
    <div className="sticky top-[6.6rem] z-40 border-y border-white/8 bg-[#07070E]/85 backdrop-blur-royal">
      <div className="mx-auto flex max-w-7xl flex-col gap-3 px-4 py-3 sm:px-6 lg:flex-row lg:items-center lg:justify-between lg:px-8">
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-4 lg:flex lg:gap-6">
          {tiles.map((t) => (
            <div key={t.label} className="flex items-center gap-2.5">
              <span
                className="flex h-9 w-9 items-center justify-center rounded-xl border border-white/10"
                style={{ background: `${t.color}1F` }}
              >
                <Icon name={t.icon} size={16} color={t.color} />
              </span>
              <div className="leading-tight">
                <div className="font-display text-sm font-bold text-white tabular-nums">{t.value}</div>
                <div className="text-[0.62rem] text-white/40">{t.label}</div>
              </div>
            </div>
          ))}
        </div>

        <div key={winner.name} className="animate-fade-in flex items-center gap-3 rounded-full border border-wa-green/25 bg-wa-green/8 px-4 py-2">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-wa-green opacity-75" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-wa-green" />
          </span>
          <span className="truncate text-xs text-white/70">
            <strong className="text-white">{winner.name}</strong> won{' '}
            <strong className="text-wa-green">{formatINR(winner.amount)}</strong> on {winner.game}
          </span>
          <span className="hidden text-[0.62rem] text-white/35 sm:inline">{winner.time}</span>
        </div>
      </div>
    </div>
  );
};

export default LiveStatsBar;
